import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["srcDoc"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("iframe", {
    ref: "editorViewer",
    title: "Editor viewer",
    class: "editor-viewer",
    srcDoc: _ctx.formattedHtmlContent
  }, null, 8, _hoisted_1);
}